import UserProfile, { UserProfileProps } from './UserProfile';

export type { UserProfileProps };
export default UserProfile;
